import type { ColumnDef, DefaultSortState } from '@/shared/types/table-filters.types';
import type { InspectionVerification } from '../types/inspection.types';

/**
 * Inspection is a queue: the backend serves it oldest response first
 * (findByStatusOrderByRespondedAtAsc), so that stays the default order rather
 * than the generic "most recently updated first".
 */
export const INSPECTION_DEFAULT_SORT: DefaultSortState = { key: 'respondedAt', dir: 'asc' };

/**
 * Filterable/sortable fields of a verification under inspection.
 * Status is deliberately absent: the tabs already scope the list to one status.
 */
export const inspectionTableColumns: ColumnDef<InspectionVerification>[] = [
  {
    key: 'candidateName',
    label: 'Candidate',
    filterType: 'text',
    accessor: (verification) => verification.candidateName,
    sortable: true,
  },
  {
    key: 'companyName',
    label: 'Company',
    filterType: 'text',
    accessor: (verification) => verification.companyName,
    sortable: true,
  },
  {
    key: 'refereeName',
    label: 'Reference contact',
    filterType: 'text',
    accessor: (verification) => verification.refereeName,
    sortable: true,
  },
  {
    key: 'refereeEmail',
    label: 'Reference contact email',
    filterType: 'text',
    accessor: (verification) => verification.refereeEmail,
    sortable: true,
  },
  {
    key: 'experienceJobTitle',
    label: 'Position',
    filterType: 'text',
    accessor: (verification) => verification.experienceJobTitle,
    sortable: true,
  },
  {
    key: 'respondedAt',
    label: 'Responded',
    filterType: 'date-range',
    accessor: (verification) => verification.respondedAt,
    sortable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    filterType: 'date-range',
    accessor: (verification) => verification.createdAt,
    sortable: true,
  },
];
